import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Card, CardTitle, CardText } from "react-md/lib/Cards";
import { getRiskProfilerResults } from "requests/collateralAnalytics";
import { MSpinner, MGrid, TextField } from "components/Shared";
import { DATA_TYPE_MULTI_LINE_STRING, DATA_TYPE_NUMBER_RAW } from "typeConstants/dataTypes";
import { dateTimeToString } from "components/Shared/Formatters";
import responseHandler from "responseHandler";

const RiskProfilerResults = ({ 
  controlNumber,
  fetchingRiskProfilerResults,
  riskProfilerResults,
  getRiskProfilerResults,
  makeToast
}) => {

  const [expanded, setExpanded] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    if (controlNumber && controlNumber !== riskProfilerResults?.controlIdNumber) getRiskProfilerResults(controlNumber, () => {}, () => makeToast("There was an error retrieving risk profiler results.", "error"), mounted);
    return () => mounted.current = false;
  }, []);

  const toggleExpanded = () => setExpanded(!expanded);

  if (fetchingRiskProfilerResults) return (<MSpinner />);

  let colDefs = [
    { key: "id", name: "ID", dataSource: "ruleRiskId", dataType: DATA_TYPE_NUMBER_RAW, width: 75 },
    { key: "question", name: "Question", dataSource: "ruleQuestion", dataType: DATA_TYPE_MULTI_LINE_STRING },
    { key: "risk", name: "Risk", dataSource: "riskLevelName", width: 150 },
    { key: "result", name: "Result", dataSource: "ruleResult", width: 100 },
  ];

  let date;
  if (riskProfilerResults?.resultsDateUtc) {
    let dateString = dateTimeToString(riskProfilerResults?.resultsDateUtc);
    let convertedDate = new Date(`${dateString} UTC`);
    date = convertedDate;
  }

  return (
    <div className="case-header">
      <Card 
        className="md-cell md-cell--12" 
        expanded={expanded} 
        onExpanderClick={toggleExpanded}
      >
        <CardTitle 
          title="Risk Profiler Results" 
          onClick={toggleExpanded} 
          expander 
          className={"risk-profiler-cardtitle"}
        />
        <CardText 
          expandable
          className={riskProfilerResults && Object.keys(riskProfilerResults).length ? "risk-profiler-cardtext-container" : "risk-profiler-container-no-results"}
        >
          {riskProfilerResults && Object.keys(riskProfilerResults).length ? <>
            <div className={"risk-profiler-summary-container"}>
              <TextField field={`Risk Score: ${riskProfilerResults.riskLevelScore}`} />
              <TextField field={`Risk Level: ${riskProfilerResults.riskLevelName}`} />
              <TextField field={`Received: ${dateTimeToString(date)}`} />
            </div>
            <MGrid 
              columnDefinitions={colDefs}
              data={riskProfilerResults?.collateralAnalyticsRiskProfilerResultDetails?.filter(rps => rps?.ruleResult?.toLowerCase() !== "pass").filter(rps => rps?.riskLevelName?.toLowerCase() !== "error")}
            />
          </> : <div className="md-cell--12">No Risk Profiler results.</div>}
        </CardText>

      </Card>
    </div>
  );
};

RiskProfilerResults.propTypes = {
  controlNumber: PropTypes.number.isRequired,
  fetchingRiskProfilerResults: PropTypes.bool.isRequired,
  riskProfilerResults: PropTypes.object,
  getRiskProfilerResults: PropTypes.func.isRequired,
  makeToast: PropTypes.func,
};

const mapStateToProps = state => {
  return {
    fetchingRiskProfilerResults: state.riskProfiler.fetchingRiskProfilerResults,
    riskProfilerResults: state.riskProfiler.riskProfilerResults,
  };
};

const mapDispatchToProps = dispatch => ({
  getRiskProfilerResults(controlNumber) {
    dispatch(getRiskProfilerResults(controlNumber));
  },
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RiskProfilerResults);